import { User } from "@sentry/types";
import firebase from "firebase/app";
import "firebase/firestore";
import { NETLFIX_PID, SPOTIFY_PID } from "./constants";

const TOTAL_PLACEHOLDER = 5;
export const getRandomPlaceholderImage = () => {
  const timestamp = Date.now();
  const index = timestamp % TOTAL_PLACEHOLDER;
  return [
    "https://firebasestorage.googleapis.com/v0/b/pulpo-club-profile-images/o/website%2FPlaceholder1.png?alt=media",
    "https://firebasestorage.googleapis.com/v0/b/pulpo-club-profile-images/o/website%2FPlaceholder2.png?alt=media",
    "https://firebasestorage.googleapis.com/v0/b/pulpo-club-profile-images/o/website%2FPlaceholder3.png?alt=media",
    "https://firebasestorage.googleapis.com/v0/b/pulpo-club-profile-images/o/website%2FPlaceholder4.png?alt=media",
    "https://firebasestorage.googleapis.com/v0/b/pulpo-club-profile-images/o/website%2FPlaceholder5.png?alt=media",
  ][index];
};

export const getFormattedTime = (
  timestamp: firebase.firestore.FieldValue,
  transformDate?: (date: Date) => Date
) => {
  const { seconds, nanoseconds } = timestamp as any;
  const time = new firebase.firestore.Timestamp(seconds, nanoseconds);
  const date = transformDate ? transformDate(time.toDate()) : time.toDate();
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
};

export const toCapital = (string: string) => {
  return string[0].toUpperCase() + string.slice(1);
};

export const isDevEnv = () => {
  return (
    process.env.NODE_ENV === "development" ||
    process.env.REACT_APP_BACKEND_ENV === "development"
  );
};

export const getRenewalDate = (groupCreationDate: Date) => {
  const currentMonth = new Date().getMonth();

  const currentDate = new Date().getDate();
  const creationDate = groupCreationDate.getDate();

  if (currentDate > creationDate) {
    const today = new Date();
    today.setDate(creationDate);
    today.setMonth(currentMonth + 1);
    return today;
  } else {
    const today = new Date();
    today.setDate(creationDate);
    return today;
  }
};

export const getPayoutDate = (firstMemberPaymentTimestamp: firebase.firestore.FieldValue) => {
  const { seconds, nanoseconds } = firstMemberPaymentTimestamp as any;
  const time = new firebase.firestore.Timestamp(seconds, nanoseconds);
  const firstMemberPaymentDate = time.toDate();

  const currentMonth = new Date().getMonth();

  const currentDate = new Date().getDate();
  const creationDate = firstMemberPaymentDate.getDate();

  if (currentDate > creationDate) {
    const today = new Date();
    today.setDate(creationDate);
    today.setMonth(currentMonth + 1);
    return `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`;
  } else {
    const today = new Date();
    today.setDate(creationDate);
    return `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`;
  }
}

// NOTE: It always assumes there is at least one member
export const getFirstJoinedMember = (subscribers: User[]) => {
  return subscribers.sort((m1, m2) => {
    const time1 = new firebase.firestore.Timestamp(
      m1.created.seconds,
      m1.created.nanoseconds
    );
    const time2 = new firebase.firestore.Timestamp(
      m2.created.seconds,
      m2.created.nanoseconds
    );
    return time1.toMillis() < time2.toMillis() ? -1 : 1;
  })[0];
};

export const add1Month = (date: Date) => {
  const newDate = new Date(date.getTime());
  newDate.setMonth(date.getMonth() + 1);
  return newDate;
};

export const requiresLegal = (platformPID: string) => {
  return [SPOTIFY_PID, NETLFIX_PID].includes(platformPID);
}

export const openNotificationPopover = () => {
  try {
    const element = document.getElementById("subscribePlatformPopoverTrigger");
    element?.click()
  } catch (e) {

  }
}

export const OPEN_PAYMENT_MODAL_QUERY = "openPayment";
const NEXT_URL_KEY = "nextURL";
export const setNextURL = (url: string) => {
  try {
    localStorage.setItem(NEXT_URL_KEY, url)
    return true;
  } catch (e) {
    console.log(e);
    return false;
  }
}
export const getNextURL = () => {
  try {
    return localStorage.getItem(NEXT_URL_KEY)
  } catch (e) {
    console.log(e);
    return null;
  }
}
export const clearNextURL = () => {
  try {
    localStorage.removeItem(NEXT_URL_KEY)
    return true;
  } catch (e) {
    console.log(e);
    return false;
  }
}